import {
  type CreateOrUpdatePolicyRequest,
  RoutingPolicyModel,
} from "@shared/types/common";
import { DateTime } from "luxon";
import { TourUrlHandlerConfig } from "@shared/types/localTypes/tour.ts";
import { constants } from "@shared/constants/constants.ts";
import { sleep } from "@shared/utils/tools.ts";

export default async (data?: object, config?: TourUrlHandlerConfig) => {
  if (config?.method === "DELETE") {
    return {};
  }

  const originalUrl = config?.originalUrl || "";
  const policyUuid = originalUrl.match(constants.UUID_REGEX)?.[0] || "";

  const request = data as CreateOrUpdatePolicyRequest;

  await sleep(350);
  return {
    createdAt: DateTime.now().toISO(),
    policy_type: request.policy_type,
    policy_status: "in_progress",
    routing_policy_id: policyUuid,
    subscription_id: request.subscription_id,
    routing_url: request.routing_url,
    policy_details: request.policy_details,
    target_jpd_technical_server_name: request.target_jpd_technical_server_name,
  } satisfies RoutingPolicyModel;
};
